import React, { PropTypes } from 'react';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Activity Feed History Button
 */
const HistoryButton = (props) => {
  return (
    <div
      onClick={props.onClick} // eslint-disable-line react/prop-types
      className="af-list-item-list-icon"
    >
      <Icon name="list" />
    </div>
  );
};

HistoryButton.propsTypes = {
  onClick: PropTypes.func,
};

export default HistoryButton;
